export enum Category {
  supermarket = 'supermarket',
  home = 'home',
  restaurant = 'restaurant',
  transport = 'transport',
  health = 'health',
  leisure = 'leisure',
  education = 'education',
  clothing = 'clothing',
  travel = 'travel',
  electronic = 'electronic',
  service = 'service',
  investment = 'investment',
  other = 'other',
}
